import { render, staticRenderFns } from "./M101.vue?vue&type=template&id=0abb3bf2&scoped=true"
import script from "./M101.vue?vue&type=script&lang=js"
export * from "./M101.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=0abb3bf2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abb3bf2",
  null
  
)

export default component.exports